import httpheader from '../shared/httpheader';

let environmentVariable = 'A1MHealth';
const cNameValue = httpheader.getCNAME();
if (
  cNameValue === 'roundstone-test' ||
  cNameValue === 'roundstone-dev' ||
  cNameValue.includes('roundstone') ||
  cNameValue === 'mybenefits'
) {
  environmentVariable = 'Bywater';
} else if (
  cNameValue.includes('keenan') ||
  cNameValue.includes('tpabenefits')
) {
  environmentVariable = 'Keenan';
}
export const IDCardEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Your ID Card Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'IDCard.pdf',
  FileName: 'IDCard.pdf',
  Message: `As requested, enclosed is your member ID card. You can use this new ID card for your next visit to the provider.If you have any questions or concerns, please call the A1MHelath member service phone number displayed on the top of your ID card.


  Sincerely,
  ${environmentVariable}.
  `,
};

export const ClaimsPDFEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Claims Transaction Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Claims.pdf',
  FileName: 'Claims.pdf',
  Message: `As per your request, please find the details of your claim transactions for the requested time period.If you have any questions or concerns, please call or Email the A1MHelath Support team.


  Sincerely,
  ${environmentVariable}.
  `,
};

export const ClaimsCSVEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Claims Transaction Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Claims.csv',
  FileName: 'Claims.csv',
  Message: `As per your request, please find the details of your claim transactions for the requested time period.If you have any questions or concerns, please call or Email the A1MHelath Support team.


  Sincerely,
  ${environmentVariable}.
  `,
};

export const AccountsPDFEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Account Transaction Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Accounts.pdf',
  FileName: 'Accounts.pdf',
  Message: `As per your request, please find the details of your account transactions for the requested time period.If you have any questions or concerns, please call or Email the A1MHelath Support team.


  Sincerely,
  ${environmentVariable}.
  `,
};

export const AccountsCSVEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Account Transaction Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Accounts.csv',
  FileName: 'Accounts.csv',
  Message: `As per your request, please find the details of your account transactions for the requested time period.If you have any questions or concerns, please call or Email the A1MHelath Support team.

  Sincerely,
  ${environmentVariable}.
  `,
};

export const DefaultCSVEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Report.csv',
  FileName: 'Report.csv',
  Message: `As per your request, please find the details.If you have any questions or concerns, please call or Email the A1MHelath Support team.

  Sincerely,
  ${environmentVariable}.
  `,
};

export const DefaultPDFEmailBody = {
  FromAddress: ' ',
  FromName: environmentVariable,
  BounceAddress: '',
  ToAddress: '',
  ToName: '',
  CcAddress: '',
  BccAddress: '',
  Subject: environmentVariable + ': Details',
  FileContent: '',
  AlternateMessage: 'NoAlt',
  FileDescription: 'Report.pdf',
  FileName: 'Report.pdf',
  Message: `As per your request, please find the details.If you have any questions or concerns, please call or Email the A1MHelath Support team.

  Sincerely,
  ${environmentVariable}.
  `,
};
